<template>
  <div>
    <table class="table table-homepage">
      <thead>
        <tr>
          <th>{{ $t('resources.occupation') }}</th>
          <th v-if="entityId">{{ $t('resources.service') }}</th>
          <th v-else>{{ $t('Offers.filters.entities') }}</th>
          <th>{{ $t('DashboardPageManager.beginning') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="offer in offers" @click="showDetails(offer)" :class="{ empty: !offer.id }">
          <td><div class="text-ellipsis">{{ offer.replaced_occupation ? offer.replaced_occupation.name : '' }}</div></td>
          <td>
            <div class="text-ellipsis" v-if="entityId">{{ offer.replaced_service ? offer.replaced_service.name : '' }}</div>
            <div class="text-ellipsis" v-else>{{ offer.entity ? offer.entity.name : '' }}</div>
          </td>
          <td><div class="date-ellipsis">{{ offer.start_at | formatDateMonthAtTime }}</div></td>
        </tr>
      </tbody>
    </table>
    <div class="clearfix"></div>
  </div>
</template>

<script>
  export default {
    name: "UpcomingTable",
    props: ['offers', 'entityId'],
    methods: {
      showDetails(offer) {
        var admin = { name: 'AdminOffer', params: { id: offer.id } }
        this.$router.push(admin)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .table-published table tbody tr:hover td:not(:empty){
    background: #FBE6D7;
    cursor: pointer;
  }

  .table-waiting table tbody tr:hover td:not(:empty) {
    background: rgb(227, 226, 253);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/manager/UpcomingTable.vue